import { PlatformService } from "../resource";
import swal from "sweetalert2";

const PlatformModule = {
    namespaced: true,
    state: {
        datum: {},

    },
    mutations: {
        SET_ORDERS(state, data) {
            state.orders = data;
        }
    },
    actions: {
		ConnectPlatform({ commit, state }, params) {
			return PlatformService.ConnectPlatform(params);
		},

    },
    getters: {
        getOrders(state) {
            return state.orders;
        }
    }
};

export default PlatformModule;
